import { keepPreviousData, useInfiniteQuery, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Button, Input, Toast } from 'antd-mobile';
import { useThrottledHandler } from 'App';
import React, { useEffect, useRef, useState } from 'react';
import UserApi, { UserDataType } from 'services/apis/sys/user-api';
import sleep from 'utils/threadUtil';

const ReactQueryComponent = () => {
  const queryClient = useQueryClient();

  const [username, setUsername] = useState(null);
  const [current, setCurrent] = useState(1);
  const defaultPageParams = { current: 1, pageSize: 2 };

  // Fetch data from the API
  const fetchUser = async () => {
    await sleep(3000);
    const response = await UserApi.page({ pageParams: { pageSize: 99, current: 1 } });
    return response.result;
  };
  // Page data from the API
  const pageUser = async ({ current, pageSize = defaultPageParams.pageSize }) => {
    await sleep(3000);
    const response = await UserApi.page({ pageParams: { pageSize: pageSize, current: current } });
    return response.result;
  };
  // Load data from the API
  const loadUser = async ({ pageParam }) => {
    await sleep(3000);
    const response = await UserApi.page({ pageParams: { pageSize: defaultPageParams.pageSize, current: pageParam } });
    return response.result.items;
  };
  // Add data from the API
  const addUser = async ({ username, password }) => {
    await sleep(3000);
    const response = await UserApi.batchSave({ users: [{ username, password }] });
    return response;
  };
  // Update data from the API
  // const alterUser = async ({ username, password }) => {
  //   sleep(3000);
  //   const response = await UserApi.batchUpdate({ users: [{ username, password }] });
  //   return response;
  // };

  // 查询: 从服务器获取数据
  const query = useQuery({
    // status告诉我们有关data的状态：有或者没有？
    // fetchStatus告诉我们有关queryFn的状态：在执行还是没在执行？
    queryKey: ['userDataList'],
    queryFn: () => fetchUser(),
    // 如果配置了持久化 PersistQueryClientProvider, 会自动加载
    // initialData: () => {
    //   const data = queryClient.getQueryData(["userDataList"]) as unknown as UserDataType[];
    //   return data;
    // },
  });

  // 修改: 向服务器添加数据
  const mutation = useMutation({
    mutationKey: ['userDataList'],
    retry: 3,
    mutationFn: addUser,
    // 当 mutate 调用时
    onMutate: async (variables) => {
      console.log('onMutate');
      // 修改即将发生！
      // （可选）返回包含回滚时使用的数据的上下文
      // return { result: { items: [{ username: "error" }] } };

      // 撤销相关的查询（这样它们就不会覆盖我们的乐观更新）
      // await queryClient.cancelQueries({ queryKey: ["userDataList"] });
      // // 保存前一次状态的快照
      // const previousData = queryClient.getQueryData(["userDataList"]);
      // // 执行"乐观"更新
      // queryClient.setQueryData(["userDataList"], (old: UserDataType[]) => {
      //   console.log(old);
      //   return [...old, { username: variables.username }];
      // });
      // // 返回具有快照值的上下文对象 (传递给 onError 和 onSettled)
      // return { previousData };
    },
    onSuccess: async (data, variables, context) => {
      // 成功处理
      console.log('onSuccess');
      // 手动设置更新
      // queryClient.setQueryData(["userDataList"], (old: UserDataType[]) => [...(old as UserDataType[]), { username: variables.username }]);
    },
    // 如果修改失败，则使用 onMutate 返回的上下文进行回滚
    onError: async (error, variables, context) => {
      // 错误触发！
      console.log('onError');
      // queryClient.setQueryData(["userDataList"], context.previousData);
    },
    onSettled: async (data, error, variables, context) => {
      // 错误或成功……这并不重要
      console.log('onSettled');
      // 总是在错误或成功之后触发新的数据获取
      queryClient.invalidateQueries({ queryKey: ['userDataList'] });
    },
  });

  // 分页查询
  const queryPage = useQuery({
    // status告诉我们有关data的状态：有或者没有？
    // fetchStatus告诉我们有关queryFn的状态：在执行还是没在执行？
    queryKey: ['userDataPage', current],
    queryFn: () => pageUser({ current }),
    placeholderData: keepPreviousData,
    // initialData: () => {
    //   const data = queryClient.getQueryData(["userDataPage"]) as unknown as UserDataType[];
    //   return data;
    // },
  });

  // 无限查询
  const infiniteQuery = useInfiniteQuery({
    queryKey: ['userDataInfinite'],
    // queryFn 函数的入参为pageParam是固定的, 否则得自行管理分页参数
    queryFn: loadUser,
    // initialData: { pages: queryClient.getQueryData(["userDataInfinite"]) as UserDataType[], pageParams: [1] },
    initialPageParam: 1,
    // maxPages: 3, // 设置后会循环请求
    getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
      if (lastPage?.length === 0) {
        return undefined;
      }
      return lastPageParam + 1;
    },
    getPreviousPageParam: (firstPage, allPages, firstPageParam, allPageParams) => {
      if (firstPageParam <= 1) {
        return undefined;
      }
      return firstPageParam - 1;
    },
    // 以相反的顺序显示页面
    // select: (data) => ({
    //   pages: [...data.pages].reverse(),
    //   pageParams: [...data.pageParams].reverse(),
    // }),
  });

  useEffect(() => {
    // const treeTermData = queryClient.getQueryData(["treeTerm"]);
    // console.log("reactQueryComponent-treeTermData", treeTermData);
    // const userDataList = queryClient.getQueryData(["userDataList"]);
    // console.log("reactQueryComponent-userDataList", userDataList);
  }, []);

  return (
    <>
      {/* 数据显示 */}
      <div className=" bg-slate-200 m-2 p-2">
        <>
          {query.isLoading && (
            <>
              <span>query isLoading...</span>
            </>
          )}
          {query.status === 'error' && (
            <>
              <span>query Error: {query.error.message}</span>
            </>
          )}
        </>
        {query.status === 'success' && query.data.items && (
          <div>
            {query.data.items
              ?.sort((a, b) => {
                return b.createTime > a.createTime;
              })
              ?.map((item: { username: string }, index: string) => (
                <div key={index}>{index + ': ' + item.username}</div>
              ))}
          </div>
        )}
      </div>

      {/* 添加数据 */}
      <div className=" bg-slate-200 m-2 p-2">
        <>
          {mutation.status === 'pending' && (
            <>
              <span>mutation Pending...</span>
            </>
          )}
          {mutation.status === 'error' && (
            <>
              <span>mutation Error: {mutation.error.message}</span>
            </>
          )}
          {mutation.status === 'idle' && (
            <>
              <span>mutation Idling...</span>
            </>
          )}
        </>
        <div className=" flex ">
          <Input
            type="text"
            placeholder="请输入用户名"
            value={username}
            onChange={(value) => setUsername(value)}
          />
          <Button
            color="warning"
            onClick={useThrottledHandler(() => {
              if (!username) {
                Toast.show('username is null');
                return;
              }
              mutation.mutate(
                { username: username, password: username },
                {
                  onSuccess: (data, variables, context) => {
                    console.log('onSuccess second');
                  },
                  onError: (error, variables, context) => {
                    console.log('onError second');
                  },
                  onSettled: (data, error, variables, context) => {
                    console.log('onSettled second');
                  },
                }
              );
              setUsername('');
            })}
          >
            addUser
          </Button>
          <Button
            color="primary"
            onClick={useThrottledHandler(() => {
              // mutation.reset();
            })}
          >
            reset
          </Button>
        </div>
      </div>

      {/* 数据分页 */}
      <div className=" bg-slate-300 m-2 p-2">
        {queryPage.status === 'success' && queryPage.data.items && (
          <div>
            {queryPage.data.items
              ?.sort((a, b) => b.createTime > a.createTime)
              ?.map((item: { username: string }, index: string) => (
                <div key={index}>{index + ': ' + item.username}</div>
              ))}
          </div>
        )}
        <Button
          onClick={useThrottledHandler(() => setCurrent((old) => Math.max(old - 1, 1)))}
          disabled={current === 1}
        >
          Previous Page
        </Button>
        <Button
          onClick={useThrottledHandler(() => {
            if (!queryPage.isPlaceholderData && Math.ceil(query.data.counts / defaultPageParams.pageSize) > current) {
              setCurrent((old) => old + 1);
            }
          })}
          // 禁用跳转下一页的按钮，直到我们知道下一页数据是可用的
          // disabled={queryPage?.isPlaceholderData && dataCount.current / defaultPageParams.pageSize < current}
          disabled={
            queryPage?.isPlaceholderData || Math.ceil(query.data?.counts / defaultPageParams.pageSize) <= current
          }
        >
          Next Page
        </Button>
        <div>{queryPage.isFetching ? <span> Loading...</span> : null}</div>
      </div>

      {/* 数据滚动 */}
      <div className=" bg-slate-400 m-2 p-2">
        <>
          {infiniteQuery.isLoading && (
            <>
              <span>infiniteQuery isLoading...</span>
            </>
          )}
          {infiniteQuery.status === 'error' && (
            <>
              <span>infiniteQuery Error: {infiniteQuery.error.message}</span>
            </>
          )}
        </>
        {infiniteQuery.status === 'success' &&
          infiniteQuery.data.pages &&
          infiniteQuery.data.pages?.map((group, i) => (
            <React.Fragment key={'group_' + i}>
              {group?.map((project, index) => (
                <p key={'group_' + i + '_' + index}>{'username: ' + project.username}</p>
              ))}
            </React.Fragment>
          ))}
        <div>
          <Button
            onClick={useThrottledHandler(() => {
              queryClient.setQueryData(['userDataInfinite'], (data) => ({
                //@ts-ignore
                pages: data.pages.slice(1),
                //@ts-ignore
                pageParams: data.pageParams.slice(1),
              }));
            })}
          >
            移除第一页
          </Button>
          <Button
            onClick={useThrottledHandler(() => {
              if (infiniteQuery.isFetching) {
                Toast.show('正在获取更多数据...');
                return;
              }
              infiniteQuery.fetchNextPage();
            })}
            disabled={!infiniteQuery.hasNextPage || infiniteQuery.isFetchingNextPage}
          >
            {infiniteQuery.isFetchingNextPage
              ? 'Loading more...'
              : infiniteQuery.hasNextPage
                ? 'Load More'
                : 'Nothing more to load'}
          </Button>
        </div>
        <div>{infiniteQuery.isFetching && !infiniteQuery.isFetchingNextPage ? 'Fetching...' : null}</div>
      </div>
    </>
  );
};

export default ReactQueryComponent;
